import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import type { TableCommandFactory } from 'components/Table/model/TableModel';

type ToggleColumnDetailCommand = {
  column: string;
};

export const toggleColumnDetail: TableCommandFactory<
  ToggleColumnDetailCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    if (draft.tableRowDetail === null) {
      stumble('Trying to toggle column detail for empty table row detail');
    } else {
      draft.tableRowDetail.expandedColumns = plainSet.toggle(command.column)(
        draft.tableRowDetail.expandedColumns,
      );
    }
  });
};
